import { lazyPage } from '@/lib/lazy-load'

const BillingAddonsPage = lazyPage(() => import('./BillingAddonsPage'))
export default BillingAddonsPage
